import { ObjectDefinition } from '../types/DataSyncItem';
import { FieldDefinition } from '../types/FieldDefinition';

import {
  Schema,
  SchemaField,
  SourceSchemaFieldType,
  DestinationSchemaFieldType,
  BaseContractFieldType,
} from '../types/Schema';

export function convertFieldType(
  type?: SourceSchemaFieldType | DestinationSchemaFieldType | BaseContractFieldType
): string {
  if (!type) return 'string';

  switch (type) {
    case DestinationSchemaFieldType.STRING:
    case SourceSchemaFieldType.STRING:
    case BaseContractFieldType.STRING:
      return 'string';
    case DestinationSchemaFieldType.INTEGER:
    case SourceSchemaFieldType.INTEGER:
    case BaseContractFieldType.INTEGER:
      return 'integer';
    case DestinationSchemaFieldType.DECIMAL:
    case SourceSchemaFieldType.DECIMAL:
    case BaseContractFieldType.DECIMAL:
      return 'decimal';
    case SourceSchemaFieldType.BOOLEAN:
    case DestinationSchemaFieldType.BOOLEAN:
    case BaseContractFieldType.BOOLEAN:
      return 'boolean';
    default:
      return 'string';
  }
}

function convertSchemaFieldV2ToObjectField(
  field: SchemaField
): FieldDefinition {
  // Handle nested object
  if (field.object_schema) {
    return {
      name: field.id,
      display_name: field.display_name,
      type: 'object',
      required: field.required,
      description: field.description,
      object_schema: {
        fields: field.object_schema.fields.map(
          convertSchemaFieldV2ToObjectField
        )
      }
    };
  }

  // Handle array
  if (field.array) {
    const baseField: FieldDefinition = {
      name: field.id,
      display_name: field.display_name,
      type: 'array',
      required: field.required,
      description: field.description,
    };

    // If array contains primitive types
    if (field.array.primitive_type) {
      baseField.array = {
        type: convertFieldType(field.array.primitive_type)
      };
    } else if (field.array.object_schema) {
      // If array contains objects
      baseField.array = {
        type: 'object',
        fields: field.array.object_schema.fields.map(
          convertSchemaFieldV2ToObjectField
        ),
      };
    } else {
      // Default fallback
      baseField.array = undefined;
    }

    return baseField;
  }

  // Handle primitive type
  return {
    name: field.id,
    display_name: field.display_name,
    type: convertFieldType(field.primitive_type),
    required: field.required,
    description: field.description,
  };
}

export function convertSchemaV2ToObjectDefinition(
  schema: Schema
): ObjectDefinition {
  return {
    object_name: schema.id,
    object_display_name: schema.display_name,
    object_icon_url: '',
    fields: schema?.fields ? schema.fields.map(convertSchemaFieldV2ToObjectField) : [],
    locale_config: schema?.locale_config,
  };
}
